const filterChangeTypes = {
    TYPE: 'TYPE',
    GROUP: 'GROUP',
    CENTER: 'CENTER',
    TIER: 'TIER',
    STATUS: 'STATUS',
    SEARCH_BY: 'SEARCH_BY',
    SEARCH: 'SEARCH',
    START_DATE: 'START_DATE',
    END_DATE: 'END_DATE',
    RESET: 'RESET',
    ALL_OPEN: 'ALL_OPEN'
};

export default filterChangeTypes;